import { Calendar, Partners, Pros } from "@gigpro/ui/Icons";
import type { NavItemLink } from "layouts/BaseLayout/types";

export const jobsList: NavItemLink = {
  type: "link",
  title: "Jobs",
  icon: <Partners />,
  path: "/locations/$locationId/hire/jobs",
};

export const candidates: NavItemLink = {
  type: "link",
  title: "Candidates",
  icon: <Pros />,
  path: "/locations/$locationId/hire/candidates",
};

export const hiringSchedule: NavItemLink = {
  type: "link",
  title: "Schedule",
  icon: <Calendar />,
  path: "/locations/$locationId/hire/schedule",
};
